import React, { useEffect, useState } from "react";
import '../index.css';
import ErrorComponent from "./components/ErrorComponent";

function Error() {
  return (
      
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-[#faf9f8] to-white text-gray-800">
        <ErrorComponent/>  
      
    </div>
  );
}



export default Error;